export default __webpack_public_path__ + "static/media/detail_big_16_1.b5e58ea0.jpg";